import { render } from "./FilterComponent.vue?vue&type=template&id=4960081a&scoped=true"
import script from "./FilterComponent.vue?vue&type=script&lang=js"
export * from "./FilterComponent.vue?vue&type=script&lang=js"

import "./FilterComponent.vue?vue&type=style&index=0&id=4960081a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4960081a"]])

export default __exports__